import { IWorkgroup, IWorkgroupPreview } from '@/interfaces/workgroups'
import { IBlock } from '@/interfaces/blocks'
import { mapPersonFields } from '@/adapters/persons'
import { mapImageFields } from '@/adapters/common'
import { blockMapper } from '@/adapters/blocks'

export function mapWorkgroupPreviewFields(item: Directus.WorkgroupPreview): IWorkgroupPreview {
  return {
    id: item.id,
    slug: item.slug,
    chief: mapPersonFields(item.chief),
    image: mapImageFields(item.image),
    ...item.translations[0],
  }
}

export function mapWorkgroupFields(item: Directus.Workgroup, locale?: string): IWorkgroup {
  const previewFields = mapWorkgroupPreviewFields(item)
  return {
    ...previewFields,
    members: item.members?.filter(member => !!member.person)?.map(member => mapPersonFields(member.person)) || [],
    blocks: item.blocks
      .filter(b => !!b.item)
      .map((block: Directus.Block) => {
        try {
          return blockMapper.get(block.collection)?.call(null, block, locale)
        } catch (error) {
          return null
        }
      })
      .filter(b => !!b?.data) as IBlock[],
  }
}
